import React, {useState, useEffect, useRef} from 'react';
import SetPasswordDialog from '../../components/organisms/Forms/SetPassword/component';
import authService from '../../services/authService';
import GeneralModal, {GeneralModalRef} from '../../components/molecules/Modals/general/component';
import SetEmailDialog from '../../components/organisms/Forms/SetEmail/component';
import {message} from "antd";

const SetPasswordPage = () => {
    const generalModalRef = useRef<GeneralModalRef>(null);
    const [showSetPasswordDialog, setShowSetPasswordDialog] = useState(false);
    const [showSetEmailDialog, setShowSetEmailDialog] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    const caseValue = searchParams.get('type');

    const [email, setEmail] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            if (caseValue == 'verification') {
                await verification();
            } else if (caseValue == 'resetPassword') {
                await resetPassword();
            }
        };

        fetchData();
    }, [token, caseValue]);

    const verification = async () => {
        try {
            const result = await authService.verifyAccount(token, caseValue);
            if (result.status === 200) {
                setEmail(result.data.email);
                setShowSetPasswordDialog(true);
            }
        } catch (error: any) {
            if (error?.response?.status === 404) {
                message.error('User with this email address does not exist!');
            }
            if (error?.response?.status === 410) {
                setEmail(error.response.data.email);
                setShowSetEmailDialog(true);
            }
            if (error?.response?.status === 400) {
                setShowSetPasswordDialog(true);
                setEmail(error.response.data.email);
            }
        }
    }

    const resetPassword = async () => {
        try {
            setShowSetPasswordDialog(true);
        } catch (error: any) {
            message.error('User with this email address does not exist!');
        }
    }

    return (
        <div style={{height: '100vh', overflow: 'hidden'}}>
            <SetPasswordDialog visible={showSetPasswordDialog} onClose={() => setShowSetPasswordDialog(false)}
                               email={email}/>
            <GeneralModal ref={generalModalRef}/>
            <SetEmailDialog visible={showSetEmailDialog} reqEmail={email} onClose={() => setShowSetEmailDialog(false)}
                            title={'Regenerate verification link'}></SetEmailDialog>
        </div>
    );
};

export default SetPasswordPage;